import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Ortak } from '../../providers/ortak';
import { BllOrtak } from '../../providers/bll/bll-ortak';

/**
 * Generated class for the CariEkstreRaporuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-cari-ekstre-raporu',
  templateUrl: 'cari-ekstre-raporu.html',
})
export class CariEkstreRaporuPage {

  // Veri modelleri
  cariler: any[] = [];
  selectedCariId: number;
  baslangicTarihi: string;
  bitisTarihi: string;
  raporData: any;
  loading: boolean = false;
  showFilters: boolean = true; // Filtre bölümünü göster/gizle

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public alert: AlertController
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CariEkstreRaporuPage');
    
    // Gelen parametreleri kontrol et
    const vwCari = this.navParams.get('vwCari');
    const selectedCariId = this.navParams.get('selectedCariId');
    
    if (vwCari && selectedCariId) {
      console.log('Cari bilgileri parametre olarak geldi:', vwCari);
      this.selectedCariId = selectedCariId;
      
      // Cari bilgilerini cariler listesine ekle (seçim için)
      this.cariler = [vwCari];
      
      // Filtre bölümünü gizle (cari zaten seçilmiş)
      this.showFilters = false;
      
      // Otomatik olarak raporu getir
      this.raporGetir();
    } else {
      // Normal modda cari listesini getir
      //this.carileriGetir();
    }
  }

  // Cari listesini getir
 
  // Raporu getir
  raporGetir() {
    

    this.loading = true;
    

    var formData = new FormData();
    formData.append("cari_id", "347");
    
    if (this.baslangicTarihi) {
      formData.append("baslangic_tarihi", "2020-01-01");
    }
    
    if (this.bitisTarihi) {
      formData.append("bitis_tarihi", "2026-01-01");
    }

    this.bllOrtak.islem(formData, "CariDetayliHareketRaporu", "", true).then(a => {
      var sonuc = <any>a;
      console.log("Rapor sonucu:", sonuc);
      
      this.loading = false;
      
      if (sonuc.Sonuc == 1) {
        this.raporData = sonuc.SonucObject;
        console.log("Rapor verisi yüklendi:", this.raporData);
        
        // Rapor yüklendikten sonra otomatik yazdırma seçeneği sun
        this.showConfirmAlert(
          "Rapor Hazır", 
          "Rapor başarıyla oluşturuldu. Yazdırmak ister misiniz?",
          () => {
            this.yazdirRapor();
          },
          () => {
            // Kullanıcı yazdırmayı reddetti, sadece raporu göster
          }
        );
      } else {
        this.showAlert("Hata", "Rapor oluşturulamadı: " + (sonuc.SonucObject || "Bilinmeyen hata"));
      }
    }).catch(error => {
      console.error("Rapor hatası:", error);
      this.loading = false;
      
      let errorMessage = "Rapor oluşturulurken bir hata oluştu. ";
      
      if (error && error.InnerException && error.InnerException.Message) {
        if (error.InnerException.Message.includes("SQL Server")) {
          errorMessage += "Veritabanı sunucusu erişilemiyor.";
        } else if (error.InnerException.Message.includes("timeout")) {
          errorMessage += "Bağlantı zaman aşımına uğradı.";
        } else {
          errorMessage += "Ağ bağlantısını kontrol edin.";
        }
      } else {
        errorMessage += "Lütfen tekrar deneyin.";
      }
      
      this.showAlert("Rapor Hatası", errorMessage);
    });
  }

  // Yazdır butonu
  yazdir() {
    if (!this.raporData) {
      this.showAlert("Uyarı", "Önce raporu oluşturun");
      return;
    }
    this.yazdirRapor();
  }

  // Raporu yazdır
  yazdirRapor() {
    console.log("Rapor yazdırılıyor...");
    
    // Yazdırma için özel CSS uygula
    const printStyle = document.createElement('style');
    printStyle.textContent = `
      @media print {
        body * { visibility: hidden; }
        .rapor-sayfasi, .rapor-sayfasi * { visibility: visible; }
        .rapor-sayfasi { 
          position: absolute; 
          left: 0; 
          top: 0; 
          width: 100%; 
          margin: 0;
          padding: 20px;
          font-size: 12px;
        }
        .rapor-baslik h1 {
          text-align: center;
          font-size: 18px;
          margin-bottom: 10px;
        }
        .rapor-tarihi {
          text-align: right;
          font-size: 10px;
          margin-bottom: 20px;
        }
        .cari-bilgiler, .ozet-bilgiler, .hareket-tablosu {
          margin-bottom: 20px;
        }
        .cari-bilgiler h2, .ozet-bilgiler h2, .hareket-tablosu h2 {
          font-size: 14px;
          margin-bottom: 10px;
          border-bottom: 1px solid #000;
          padding-bottom: 5px;
        }
        .bilgi-tablosu, .ozet-tablosu, .veri-tablosu {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 10px;
        }
        .bilgi-tablosu td, .ozet-tablosu td, .veri-tablosu td, .veri-tablosu th {
          border: 1px solid #000;
          padding: 4px;
          font-size: 10px;
        }
        .veri-tablosu th {
          background-color: #f0f0f0;
          font-weight: bold;
        }
        .tutar {
          text-align: right;
        }
        .bakiye.negatif {
          color: red;
          font-weight: bold;
        }
        .bakiye-satiri {
          background-color: #f9f9f9;
          font-weight: bold;
        }
        ion-header, ion-content > ion-card, .rapor-container > button {
          display: none !important;
        }
      }
    `;
    
    document.head.appendChild(printStyle);
    
    // Yazdırma işlemini başlat
    window.print();
    
    // Stili temizle
    setTimeout(() => {
      document.head.removeChild(printStyle);
    }, 1000);
  }

  // Alert göster
  showAlert(baslik: string, mesaj: string) {
    let alert = this.alert.create({
      title: baslik,
      subTitle: mesaj,
      buttons: ['Tamam']
    });
    alert.present();
  }

  // Onay alerti göster
  showConfirmAlert(baslik: string, mesaj: string, onay: () => void, iptal: () => void) {
    let confirm = this.alert.create({
      title: baslik,
      message: mesaj,
      buttons: [
        {
          text: 'Hayır',
          handler: iptal
        },
        {
          text: 'Evet',
          handler: onay
        }
      ]
    });
    confirm.present();
  }

  // Tarih formatını düzenle
  formatTarih(tarih: string): string {
    if (!tarih) return '';
    
    try {
      const date = new Date(tarih);
      return date.toLocaleDateString('tr-TR');
    } catch (error) {
      return tarih;
    }
  }

  // Sayfa yüklendiğinde
  ionViewWillEnter() {
    // Sayfa her açıldığında cari listesini yenile
    this.raporGetir();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cari-ekstre-raporu/cari-ekstre-raporu.ts